import * as React from "react";
import Box from "@mui/material/Box";
import { useState } from "react";
import { TextField } from "@mui/material";
import styles from "./navbar.module.css";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Pause, Restore } from "@mui/icons-material";
import Events from "./Events";
import useTimerStore from "store/timer";
import sound from "assets/sound/notification.m4a";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogTitle,
} from "@mui/material";

export default function EventNotificationMenu({ todayEvents, weeklyEvents }) {
  const audio = new Audio(sound);
  const [date, setDate] = useState(new Date());
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [seconds, setSeconds] = useState("");
  const {
    timer,
    updateSeconds,
    updateMinutes,
    updateHours,
    updateMinutesSecond,
    updateHoursMinutesSecond,
    setTimerStart,
    clearTimer,
  } = useTimerStore();
  const [dilog, setDilog] = useState(false);

  React.useEffect(() => {
    const time = setInterval(() => setDate(new Date()), 1000);

    return () => {
      clearInterval(time);
    };
  });

  React.useEffect(() => {
    if (!timer.start) return;

    if (timer.pause) return;

    if (
      Number(timer.s) === 0 &&
      Number(timer.m) === 0 &&
      Number(timer.h) === 0
    ) {
      audio.loop = false;
      audio.play();
      setDilog(true);
      setTimerStart({ start: false, pause: true });
    }
    // eslint-disable-next-line
  }, [timer]);

  React.useEffect(() => {
    if (!timer.start) return;

    if (timer.pause) return;
    const time = setInterval(() => {
      if (Number(timer.s)) {
        return updateSeconds(Number(timer.s) - 1);
      }

      if (Number(timer.m) && Number(timer.s) === 0) {
        return updateMinutesSecond({
          s: 59,
          m: Number(timer.m) - 1,
        });
      }

      if (Number(timer.h) && Number(timer.m) === 0 && Number(timer.s) === 0)
        return updateHoursMinutesSecond({
          h: Number(timer.h) - 1,
          s: 59,
          m: 59,
        });
    }, 1000);

    return () => {
      clearInterval(time);
    };
  });

  const handleClose = () => {
    setDilog(false);
  };

  const handleHourChange = (e) => {
    if (e.target.value?.length <= 2) {
      setHours(e.target.value);
      updateHours(e.target.value);
    }
  };

  const handleMinutesChange = (e) => {
    if (e.target.value?.length <= 2) {
      setMinutes(e.target.value);
      updateMinutes(e.target.value);
    }
  };

  const handleSecondsChange = (e) => {
    if (e.target.value?.length <= 2) {
      setSeconds(e.target.value);
      updateSeconds(e.target.value);
    }
  };

  const handleTimer = () => {
    setTimerStart({ start: true, pause: !timer.pause });
  };

  const handleResetTimer = () => {
    clearTimer();
    setHours("");
    setMinutes("");
    setSeconds("");
  };

  return (
    <React.Fragment>
      <Box
        className={styles.timer_date_box}
        sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <div className="d-flex">
          <div className={styles.set_timer_div}>
            <TextField
              hiddenLabel
              id="filled-hidden-label-small"
              placeholder="h"
              variant="filled"
              size="small"
              value={hours}
              onChange={handleHourChange}
              className={styles.set_timer}
            />
            <span className="font-weight-bold px-1">:</span>
            <TextField
              hiddenLabel
              id="filled-hidden-label-small"
              placeholder="m"
              variant="filled"
              size="small"
              value={minutes}
              onChange={handleMinutesChange}
              className={styles.set_timer}
            />
            <span className="font-weight-bold px-1">:</span>
            <TextField
              hiddenLabel
              id="filled-hidden-label-small"
              placeholder="s"
              variant="filled"
              size="small"
              value={seconds}
              onChange={handleSecondsChange}
              className={styles.set_timer}
            />
            <IconButton size="small" onClick={handleTimer}>
              {timer.pause ? (
                <PlayArrowIcon fontSize="small" />
              ) : (
                <Pause fontSize="small" />
              )}
            </IconButton>
          </div>
          <div className={styles.set_timer_div}>
            <div className="font-weight-bold">
              {timer?.h < 10 ? "0" + timer.h : timer.h} :{" "}
              {timer?.m < 10 ? "0" + timer.m : timer.m} :{" "}
              {timer?.s < 10 ? "0" + timer.s : timer.s}{" "}
            </div>
          </div>
          <IconButton size="small" onClick={handleResetTimer}>
            <Restore fontSize="small" />
          </IconButton>
        </div>
        <div className={styles.current_time}>
          {date?.toLocaleTimeString()?.split(":")[0] +
            " : " +
            date?.toLocaleTimeString()?.split(":")[1] +
            " : " +
            date?.toLocaleTimeString()?.split(":")[2]}
        </div>

        <div className={styles.event_large}>
          <Events todayEvents={todayEvents} weeklyEvents={weeklyEvents} />
        </div>
      </Box>
      <Dialog
        open={dilog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" color="inherit">
          {"Timer Completed!"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} autoFocus color="success">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
